import { useRef, useState } from "react";
import styles from "./append.module.scss"
import { createPortal } from "react-dom";
import { Popup } from "../popup/popup";
import { StoreMallDirectorySharp } from "@material-ui/icons";

function ToggleButton({ option }) {
	const [selected, setSelected] = useState(0);
	const itemRef = useRef({});
	const windowRef = useRef(null);

	if(!Array.isArray(option) || option?.length === 0) return null;
	return (
		<div className={styles.toggle}>
			{/* {option?.length > 0 && <div className={styles.toggle__window} ref={windowRef}/>} */}
			{option?.map((item, idx) => (
				<button
					key={`${item.text}-${idx}`}
					ref={node => {
						if (node) itemRef.current[idx] = node;
						else delete itemRef.current[idx];
					}}
					className={`${styles.toggle__item} ${selected === idx ? `${styles['toggle__item--selected']}` : ''}`}
					onClick={(e) => {
						if (windowRef.current) {
							console.log(itemRef)
							windowRef.current.style.left = `calc(${itemRef.current[idx].offsetWidth * idx}px + 5px)`;
							windowRef.current.style.width = `calc(${itemRef.current[idx].offsetWidth}px - 10px)`;
						}
						setSelected(idx);
						
						item?.onClick(e);
					}}
				>
					{item?.text}
				</button>
			))}
		</div>
	)
}

export function Append({onChangeBizType}) {
	const [isPopup, setIsPopup] = useState(false);

	return (
		<div className={styles.append}>
			{isPopup && createPortal(<Popup onClose={() => setIsPopup(false)}/>, document.body)}
			<ToggleButton option={[
				{ text: '보급사업', onClick: () => onChangeBizType('bpm'), },
				{ text: '산업단지', onClick: () => onChangeBizType('rps'), },
			]}/>

			<button className={styles.help} onClick={() => setIsPopup(true)}>
				충남REMS란?
			</button>
		</div>
	)
}